import { render, staticRenderFns } from "./BeneficiaryStatusToggleButton.vue?vue&type=template&id=36337263&"
import script from "./BeneficiaryStatusToggleButton.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryStatusToggleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports